module.exports = __webpack_public_path__ + "media/audio10.7d8efd72.mp3";